import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-report-share-public-copy-link',
  templateUrl: './report-share-public-copy-link.component.html',
  styleUrls: ['./report-share-public-copy-link.component.scss']
})
export class ReportSharePublicCopyLinkComponent {
  @Input() public type: 'button' | 'icon' = 'button';
  @Input() public link: string;

  constructor() { }
}
